import { i18n } from 'core/localization';
import { IncidentsGridWidgetConfig } from 'areas/incidents/widgets/IncidentsGridWidget/config';
import { ApplicationState } from 'framework/applicationState';
import IncidentsGridWidget from 'areas/incidents/widgets/IncidentsGridWidget/index';
import { Editor } from './editor';
import { WidgetDescription } from 'controls/designer/features/widgets/types';

export function getWidgetDescription(): WidgetDescription<IncidentsGridWidgetConfig> {
	return {
		form: Editor,
		defaultConfig: {
			type: 'incidents-grid',
			title: i18n('Incidents'),
			accountIds: [ApplicationState.accountId],
			tags: [],
			includeSubaccounts: false,
			gridToolbarVisibility: {
				showViewSelector: true,
				showFilters: true,
				showTimeSettings: true,
				showRefreshTimer: true,
			},
		},
		minWidth: 800,
		containerStyle: (config) => {
			return {
				transparent: true,
				noBorder: true,
			};
		},
		widget: IncidentsGridWidget,
		fullTitle: i18n('Incidents'),
	};
}
